import {type ReactNode} from 'react'
import HgWYSIWYGContainer from '../_components'

export const LEGAL_WYSIWYG_TYPE = 'legal'
export type LegalWYSIWYGType = typeof LEGAL_WYSIWYG_TYPE

const HgLegalWYSIWYGContainer = ({children}: {children: ReactNode}) => {
  return <HgWYSIWYGContainer>{children}</HgWYSIWYGContainer>
}

export default HgLegalWYSIWYGContainer
